// extracted by mini-css-extract-plugin
export default {"header":"style_header__HHPI3","logo":"style_logo__W8n6n","headerMenu":"style_headerMenu__BeC0L"};